// Inject a hamburger toggle into the main navigation bar and wire up the
// open/close behavior. Run on every page that has `.navigation-bar`.

export default function setupMobileNav() {
  const navBar = document.querySelector('.navigation-bar');
  const navList = navBar && navBar.querySelector('.navigation');
  if (!navBar || !navList) return;

  // Idempotent: don't add a second button if one already exists.
  if (navBar.querySelector('.nav-toggle')) return;

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'nav-toggle';
  button.setAttribute('aria-label', 'Toggle menu');
  button.setAttribute('aria-expanded', 'false');
  button.innerHTML = '<span></span><span></span><span></span>';
  navBar.appendChild(button);

  function close() {
    button.classList.remove('nav-toggle--open');
    navList.classList.remove('navigation--open');
    button.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('nav-menu-open');
  }

  function toggle(e) {
    e.stopPropagation();
    const isOpen = navList.classList.toggle('navigation--open');
    button.classList.toggle('nav-toggle--open', isOpen);
    button.setAttribute('aria-expanded', String(isOpen));
    document.body.classList.toggle('nav-menu-open', isOpen);
  }

  button.addEventListener('click', toggle);

  navList.querySelectorAll('a').forEach((a) => {
    a.addEventListener('click', close);
  });

  document.addEventListener('click', (e) => {
    if (!navList.contains(e.target) && !button.contains(e.target)) close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
}
